var map = {
	"./actions/arrow-left.svg": 1314,
	"./actions/arrow-right.svg": 1316,
	"./actions/clear.svg": 1317,
	"./actions/close.svg": 1318,
	"./actions/copy-paste.svg": 1319,
	"./actions/copy.svg": 1320,
	"./actions/edit.svg": 1321,
	"./actions/follow-link.svg": 1322,
	"./actions/home.svg": 1323,
	"./actions/search.svg": 1324,
	"./activatable/2fa.svg": 1325,
	"./activatable/career-status.svg": 1326,
	"./activatable/contract-addresses.svg": 1327,
	"./activatable/dashboard.svg": 1328,
	"./activatable/default.svg": 1329,
	"./activatable/event.svg": 1330,
	"./activatable/help-center.svg": 1331,
	"./activatable/hub.svg": 1332,
	"./activatable/info.svg": 1333,
	"./activatable/languages.svg": 1334,
	"./activatable/learn.svg": 1335,
	"./activatable/log-out.svg": 1336,
	"./activatable/map.svg": 1337,
	"./activatable/marketplace.svg": 1338,
	"./activatable/metaverses.svg": 1339,
	"./activatable/my-team.svg": 1340,
	"./activatable/partnership.svg": 1341,
	"./activatable/products.svg": 1342,
	"./activatable/profile.svg": 1343,
	"./activatable/promo.svg": 1344,
	"./activatable/settings.svg": 1345,
	"./activatable/theme.svg": 1346,
	"./activatable/wallet.svg": 1347,
	"./arrows/arrow-right.svg": 1348,
	"./arrows/back.svg": 1349,
	"./arrows/down-rounded.svg": 1350,
	"./arrows/down.svg": 1351,
	"./arrows/forward.svg": 1352,
	"./arrows/less-fill.svg": 1353,
	"./arrows/less.svg": 1354,
	"./arrows/more-fill.svg": 1355,
	"./arrows/more-right.svg": 1356,
	"./arrows/more.svg": 1357,
	"./arrows/right.svg": 1358,
	"./arrows/s-shapeIcon.svg": 1359,
	"./arrows/unfold-more.svg": 1360,
	"./arrows/up.svg": 1361,
	"./currency/bitopex.svg": 1362,
	"./currency/btc.svg": 1363,
	"./currency/gymnet.svg": 1364,
	"./currency/moonberg.svg": 1365,
	"./currency/pap.svg": 1366,
	"./currency/usdt.svg": 1367,
	"./currency/utility.svg": 1368,
	"./general/asterisk.svg": 1369,
	"./general/burger-menu.svg": 1370,
	"./general/check-blue-rounded.svg": 1371,
	"./general/check.svg": 1372,
	"./general/dark-mode.svg": 1373,
	"./general/discount.svg": 1374,
	"./general/dot.svg": 1375,
	"./general/eye-off.svg": 1376,
	"./general/eye-on.svg": 1377,
	"./general/indeterminate.svg": 1378,
	"./general/info-fill.svg": 1379,
	"./general/info.svg": 1380,
	"./general/key.svg": 1381,
	"./general/languages.svg": 1382,
	"./general/left-legs.svg": 1383,
	"./general/light-mode.svg": 1384,
	"./general/loading-animation.svg": 1385,
	"./general/lock.svg": 1386,
	"./general/magic.svg": 1387,
	"./general/minus.svg": 1388,
	"./general/notification.svg": 1389,
	"./general/plus.svg": 1390,
	"./general/refresh.svg": 1391,
	"./general/right-legs.svg": 1392,
	"./general/settings.svg": 1393,
	"./general/sound-off.svg": 1394,
	"./general/sound-on.svg": 1395,
	"./general/star.svg": 1396,
	"./general/table.svg": 1397,
	"./general/time.svg": 1398,
	"./general/tree.svg": 1399,
	"./general/wallet.svg": 1400,
	"./partners/full-size/alpaca.svg": 1401,
	"./partners/full-size/bitmart.svg": 1402,
	"./partners/full-size/bitopex.svg": 1403,
	"./partners/full-size/finstreet.svg": 1404,
	"./partners/full-size/imfx.svg": 1405,
	"./partners/full-size/ivendpay.svg": 1406,
	"./partners/full-size/lbank.svg": 1407,
	"./partners/full-size/mercuryo.svg": 1408,
	"./partners/full-size/pancake-swap.svg": 1409,
	"./partners/full-size/swapin.svg": 1410,
	"./partners/full-size/trustpilot.svg": 1411,
	"./partners/full-size/workin.svg": 1412,
	"./partners/full-size/xtcom.svg": 1413,
	"./partners/full-size/zypto.svg": 1414,
	"./project-specific/h-power-1.svg": 1415,
	"./project-specific/h-power-2.svg": 1416,
	"./project-specific/h-power-3.svg": 1417,
	"./project-specific/th-power.svg": 1418,
	"./social-media/facebook.svg": 1419,
	"./social-media/instagram.svg": 1420,
	"./social-media/linkedin-colored.svg": 1421,
	"./social-media/linkedin.svg": 1422,
	"./social-media/x.svg": 1423,
	"./social-media/youtube.svg": 1424,
	"./third-party/zendesk-messenger.svg": 1425,
	"./two-tone/active-partners.svg": 1426,
	"./two-tone/big-earn.svg": 1427,
	"./two-tone/big-easy.svg": 1428,
	"./two-tone/big-empowering-affiliates.svg": 1429,
	"./two-tone/big-globus.svg": 1430,
	"./two-tone/big-info.svg": 1431,
	"./two-tone/big-integration.svg": 1432,
	"./two-tone/big-legacy.svg": 1433,
	"./two-tone/big-magic.svg": 1434,
	"./two-tone/big-network.svg": 1435,
	"./two-tone/big-not-complete.svg": 1436,
	"./two-tone/big-notifications.svg": 1437,
	"./two-tone/big-planet.svg": 1438,
	"./two-tone/big-profitable.svg": 1439,
	"./two-tone/big-start.svg": 1440,
	"./two-tone/big-success.svg": 1441,
	"./two-tone/direct-partners.svg": 1442,
	"./two-tone/expired.svg": 1443,
	"./two-tone/inactive-partners.svg": 1444,
	"./two-tone/income-partner.svg": 1445,
	"./two-tone/left-leg.svg": 1446,
	"./two-tone/magic.svg": 1447,
	"./two-tone/my-team.svg": 1448,
	"./two-tone/no-data.svg": 1449,
	"./two-tone/right-leg.svg": 1450,
	"./two-tone/total-income.svg": 1451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1313;